/* eslint-disable import/no-extraneous-dependencies */
import { useOidc } from "@iso/helpers/oidc";
import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import LazyLoading from "../../component/LazyLoading";

const Login = () => {
   const { login, isAuthenticated } = useOidc();

   const [allowRedirect, setAllowRedirect] = React.useState(false);

   useEffect(() => {
      // Don't trigger login if we're on the OIDC callback path (code exchange in progress)
      const isCallback = window.location.pathname.includes(
         "/authentication/callback"
      );
      if (!isAuthenticated && !isCallback) {
         // Small delay to avoid racing with OIDC callback processing
         const timer = setTimeout(() => {
            login();
         }, 100);
         return () => clearTimeout(timer);
      }

      if (isAuthenticated) {
         const timer = setTimeout(() => {
            setAllowRedirect(true);
         }, 500);
         return () => clearTimeout(timer);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [isAuthenticated]);

   // If authenticated, redirect to default page
   if (isAuthenticated && allowRedirect) {
      return <Redirect to={{ pathname: "/choose-system" }} />;
   }

   return <LazyLoading />;
};

export default Login;
